import {
  CustomUploadResponse,
  deserify,
  DocumentViewer,
  FilterSortPopup,
  firstLetterImage,
  getDeviceType,
  getFileExtensionType,
  getFileSizeInMB,
  getFileType,
  getLocalStorage,
  getMediaBasePath,
  IconWrapper,
  ImageWrapper,
  IStyles,
  Loader,
  NoContentCard,
  PrimaryButton,
  pxToRem,
  pxTovW,
  ReportButton,
  ScoreProgressBar,
  StudentScoreCard,
  theme,
  uploadFile,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import { Box, Button, Popover, Typography, useMediaQuery } from '@mui/material';
import { useGlobalContext } from 'apps/teacher/src/app/Context/GlobalContextProvider';
import { OmrIconDetails } from './components/OmrIconDetails';
import { ChangeEvent, DragEvent, MouseEvent, useEffect, useState } from 'react';
import { setToastInfoV2 } from '../../../Home/reducer/homeDashboard.slice';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../reduxStore/reduxHooks';
import {
  FileUploadPurpose,
  MimeEnum,
  SignedUrlReponse,
} from '@protos/learning_management/lms.common.apis_pb';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { CloudUpload } from '@protos/learning_management/lms.db_pb';
import { CustomUploadFileResponse } from '../../reducer/assessmentFlow.slice';
import { OmrUploadPopup } from './components/OmrUploadPopup';
import { Timestamp } from '@bufbuild/protobuf';
import { AssessmentContent } from '@protos/learning_management/lms.assessment.common.apis_pb';
import {
  StudentOmrPerformanceInfo,
  TeacherOmrAssessmentClassStats,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { ConnectError } from '@bufbuild/connect';
import { FileEnum } from '@protos/content_management/content.db_pb';
import { useParams } from 'react-router-dom';

const styles: IStyles = {
  root: {
    width: '100vw',
    padding: {
      md: `${pxTovW(15)} ${pxTovW(20)}`,
      lg: `${pxTovW(15)} ${pxTovW(240)}`,
    },
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(30) },
  },
  header: {
    width: '100%',
    display: 'flex',

    gap: { xs: pxToRem(10), md: pxTovW(22) },
    alignItems: 'center',
  },
  headImage: {
    width: { xs: pxToRem(74), md: pxToRem(50), lg: pxTovW(124) },
    height: { xs: pxToRem(74), md: pxToRem(50), lg: pxTovW(124) },
    borderRadius: { xs: pxToRem(6), md: pxToRem(6), lg: pxTovW(15) },
    objectFit: 'cover',
  },
  popoverBox: {
    '& > :nth-of-type(3)': {
      width: { xs: pxTovW(277), md: pxTovW(350), lg: pxTovW(277) },
      height: 'max-content',
      // overflow: 'hidden',
      backgroundColor: '#F8FCFF',
      boxShadow: `0px 6px ${pxToRem(24)} #00000030`,
      borderRadius: {
        xs: `${pxToRem(30)} ${pxToRem(30)} 0 0`,
        md: pxToRem(15),
      },
      marginTop: '10px',
    },
  },
  popoverItem: {
    borderBottom: '1px solid #E8E8E8',
    display: 'flex',
    justifyContent: 'space-between',
    width: pxTovW(277),
    padding: `${pxToRem(11)} ${pxToRem(20)}`,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: { md: '#ECFFF5' },
    },
  },

  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(30) },
  },
  countFilterSortBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  studentCountBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
  },
  startInfoBox: {
    // textAlign: 'center',
    display: 'flex',
    // justifyContent: 'center',
    gap: { xs: pxToRem(7), md: pxTovW(7) },
  },
  startInfoIcon: {
    width: { xs: pxToRem(10), md: pxTovW(25) },
    height: { xs: pxToRem(10), md: pxTovW(25) },
  },
  filterSortBox: {
    display: 'flex',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
  },
  studentScoreCardGridBox: {
    width: { xs: '100%', md: '100%', lg: '100%' },
    paddingY: { xs: pxToRem(7), md: pxTovW(30) },
    paddingX: { xs: pxToRem(15), md: pxTovW(20) },
    boxShadow: `0px 0px ${pxToRem(13)} #E0DFDE`,
    backgroundColor: '#FFFFFF',
    borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: { xs: pxToRem(20), md: pxTovW(30) },
    boxSizing: 'border-box',
  },
};

export const OmrActive = () => {
  const dispatch = useAppDispatch();
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const teacher_id = getLocalStorage('userId');
  const { assessment_id } = useParams();
  const { isIpadOnly } = useGlobalContext();
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const {
    LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler,
    LmsCommonAPIServiceV2ClientWithStatusCodeHandler,
    SchoolAssessmentAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler,
    SchoolAssessmentAPIServiceV2ClientWithStatusCodeHandler,
  } = useCommonServiceClientContext();

  const [activeAssessment, setActiveAssessment] = useState<
    AssessmentContent | undefined
  >(undefined);
  const [omrClassStats, setOmrClassStats] = useState<
    TeacherOmrAssessmentClassStats | undefined
  >(undefined);
  const [pdfUrl, setPdfUrl] = useState<string | undefined>(undefined);

  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<CustomUploadResponse[] | undefined>();
  const [openOmrUploadPopup, setOpenOmrUploadPopup] = useState(false);

  // -----------------------------------------------------

  const handleDropFunction = async (event: DragEvent<HTMLDivElement>) => {
    await uploadStudentData(event.dataTransfer.files);
  };
  const handleChangeFunction = async (event: ChangeEvent<HTMLInputElement>) => {
    await uploadStudentData(event.target.files as FileList);
    // Reset input value so selecting the same file again triggers onChange
    if (event.target) event.target.value = '';
  };
  const handleDeleteFunction = async (indexToDelete: number) => {
    // if (!custom_resource_data) return;
    // const tempUserUploads = [
    //   ...custom_resource_data.custom_resource_uploaded_files,
    // ];
    // tempUserUploads[indexToDelete].uploadFileData.isDeleted = true;
    // dispatch(
    //   setCustomResourceData({
    //     ...custom_resource_data,
    //     custom_resource_uploaded_files: tempUserUploads,
    //   })
    // );
    setFile(undefined);
  };

  // -----------------------------------------------------

  const hasSuccessfulUpload = file?.some(
    (upload) =>
      !upload.uploadFileData.isDeleted && upload.fileUploadStatus === 'success'
  );

  const uploadStudentData = async (filesToUpload: FileList) => {
    if (!filesToUpload?.length) return;

    if (filesToUpload.length > 1) {
      dispatch(
        setToastInfoV2({
          variant: 'error',
          label: 'Only one file can be uploaded at a time.',
          open: true,
        })
      );
      return;
    }

    const selectedFile = filesToUpload[0];
    if (!selectedFile) return;

    if (hasSuccessfulUpload) {
      dispatch(
        setToastInfoV2({
          variant: 'error',
          label: 'Only one file can be added at a time.',
          open: true,
        })
      );
      return;
    }

    if (
      ![
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ].includes(selectedFile.type)
    ) {
      dispatch(
        setToastInfoV2({
          label: 'Please upload a valid Excel file (.xls or .xlsx)',
          variant: 'error',
          open: true,
        })
      );

      return;
    }

    const tempUserUploads: CustomUploadFileResponse = {
      uploadFileData: new CloudUpload({
        gcpFileUrl: '',
        personId: user_info?.teacherProfileId,
        fileSizeInMb: getFileSizeInMB(selectedFile.size),
        isDeleted: false,
        fileName: selectedFile.name,
        fileType: getFileType(selectedFile.type),
        fileExtensionType: getFileExtensionType(selectedFile.type),
        isUploaded: false,
        signedUrl: '',
      }),
      fileUploadStatus: 'pending',
      fileSize: selectedFile.size,
    };

    setFile([tempUserUploads]);

    try {
      setLoading(true);

      const signedUrlResponse: SignedUrlReponse =
        await LmsCommonAPIServiceV2ClientWithStatusCodeHandler.getSignedUrlForFileUpload(
          {
            personId: BigInt(teacher_id),
            filesInfo: [
              {
                originalFilePath: selectedFile.name,
                mimeType: MimeEnum.MIME_XLSX,
                size:
                  getFileSizeInMB(selectedFile.size) < 0.01
                    ? 0.01
                    : getFileSizeInMB(selectedFile.size),
              },
            ],
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            fileUploadPurpose: FileUploadPurpose.FILE_UPLOAD_FOR_OMR_IMPORT,
            schoolId: user_info?.schoolDetails[0]?.schoolId,
          }
        );

      if (signedUrlResponse && signedUrlResponse.response.length > 0) {
        tempUserUploads.uploadFileData.signedUrl =
          signedUrlResponse.response[0].signedUrl;
        const signedUrl = getMediaBasePath(
          signedUrlResponse.response[0].signedUrl
        );
        const uploadSuccess = await uploadFile({
          file: selectedFile,
          signedUrl,
        });
        if (uploadSuccess.success === true) {
          // If upload is successful, update status to 'success'
          tempUserUploads.uploadFileData.gcpFileUrl =
            signedUrlResponse.response[0].signedUrl;
          tempUserUploads.uploadFileData.isUploaded = true;
          tempUserUploads.fileUploadStatus = 'success';
          setFile([tempUserUploads]);
          const uploadExcelResponse =
            await SchoolAssessmentAPIServiceV1ClientWithStatusCodeHandler.importOmrResponsesFromExcel(
              {
                assessmentId: Number(assessment_id),
                filesInfo: [tempUserUploads.uploadFileData],
                // dateOfAssessment:
                dateOfAssessment: Timestamp.fromDate(
                  new Date('2026-05-14T10:30:00Z')
                ),
              }
            );
          setFile([]);
          setOpenOmrUploadPopup(false);
          dispatch(
            setToastInfoV2({
              variant: 'success',
              label: 'OMR responses imported successfully',
              open: true,
            })
          );
          await getClassStats();
        } else {
          tempUserUploads.uploadFileData.isUploaded = false;
          tempUserUploads.fileUploadStatus = 'Upload Error';
          setFile([]);
        }
        // if (uploadSuccess.success === true) {
        //   tempUserUploads.uploadFileData.gcpFileUrl =
        //     signedUrlResponse.response[0].signedUrl;
        //   tempUserUploads.uploadFileData.isUploaded = true;
        //   tempUserUploads.fileUploadStatus = 'success';
        //   setFile([tempUserUploads]);

        //   const uploadExcelResponse =
        //     await SchoolAssessmentAPIServiceV1ClientWithStatusCodeHandler.importOmrResponsesFromExcel(
        //       {
        //         assessmentId: Number(assessment_id),
        //         filePath: signedUrlResponse.response[0].signedUrl,
        //         // dateOfAssessment:
        //         dateOfAssessment: Timestamp.fromDate(
        //           new Date('2026-05-14T10:30:00Z')
        //         ),
        //       }
        //     );

        //   console.log('uploadExcelResponse:', uploadExcelResponse);
        // } else {
        //   tempUserUploads.uploadFileData.isUploaded = false;
        //   tempUserUploads.fileUploadStatus = 'Upload Error';
        //   setFile([tempUserUploads]);
        // }
      }
    } catch (error: any) {
      dispatch(
        setToastInfoV2({
          variant: 'error',
          label: error.rawMessage
            ? error.rawMessage?.replace(/.*\]\s*/, '').trim()
            : error.message
            ? error.message.replace(/.*\]\s*/, '').trim()
            : 'Error occurred while uploading assessment',
          open: true,
        })
      );
      setFile([]);
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------------------------------

  const getAssessmentContent = async () => {
    try {
      if (!user_info?.teacherProfileId || !assessment_id) {
        return;
      }
      setLoading(true);
      const activeAssessment =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: user_info.teacherProfileId,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            assessmentId: Number(assessment_id),
          }
        );
      setActiveAssessment(activeAssessment.data);
      console.log('activeAssessment:', activeAssessment.data);
      await getClassStats();
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
      dispatch(
        setToastInfoV2({
          variant: 'error',
          label: 'Error occurred while deleting assessment',
          open: true,
        })
      );
    }
  };

  // -----------------------------------------------------

  const getClassStats = async () => {
    try {
      setLoading(true);
      const response =
        await LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler.getOmrAssessmentClassStats(
          { assessmentId: Number(assessment_id) }
        );
      setOmrClassStats(response.data);
      console.log('response:', response.data);
    } catch (err) {
      console.log(err);
      setLoading(false);
      dispatch(
        setToastInfoV2({
          variant: 'error',
          label: 'Error occurred while deleting assessment',
          open: true,
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------------------------------

  useEffect(() => {
    getAssessmentContent();
  }, []);

  // -----------------------------------------------------

  const fetchStudentBulkReports = async () => {
    try {
      if (!assessment_id) {
        dispatch(
          setToastInfoV2({
            label: 'Assessment ID is required',
            variant: 'error',
            open: true,
          })
        );
        return;
      }
      setLoading(true);
      const res =
        await SchoolAssessmentAPIServiceV2ClientWithStatusCodeHandler.fetchStudentsOMRAssessmentBulkReport(
          {
            assessmentId: Number(assessment_id),
          }
        );
      if (res.data?.bulkReportUrl) {
        if (getDeviceType() === 'android') {
          const url = getMediaBasePath(res.data.bulkReportUrl, undefined, true);
          try {
            window.Android.redirectToBrowser(url);
          } catch (error) {
            window.open(url, '_blank');
          }
        } else {
          const url = getMediaBasePath(res.data.bulkReportUrl);
          window.open(url, '_blank');
        }
      } else {
        dispatch(
          setToastInfoV2({
            label: res.message,
            variant: 'success',
            open: true,
          })
        );
      }
      setLoading(false);
    } catch (err) {
      if (err instanceof ConnectError) {
        console.log('Error:', err.rawMessage);
        dispatch(
          setToastInfoV2({
            label: err.rawMessage,
            variant: 'error',
            open: true,
          })
        );
      } else {
        dispatch(
          setToastInfoV2({
            label: 'Error while generating reports',
            variant: 'error',
            open: true,
          })
        );
      }
      setLoading(false);
    }
  };

  // -----------------------------------------------------

  const fetchTeacherReport = async () => {
    try {
      if (!assessment_id) {
        return;
      }
      setLoading(true);
      const res =
        await SchoolAssessmentAPIServiceV2ClientWithStatusCodeHandler.fetchOmrTeacherAssessmentReport(
          {
            assessmentId: Number(assessment_id),
            teacherId: user_info?.teacherProfileId,
          }
        );
      if (res.data?.gcpReportUrl) {
        setPdfUrl(getMediaBasePath(res.data?.gcpReportUrl));
      } else {
        dispatch(
          setToastInfoV2({
            label: res.message,
            variant: 'success',
            open: true,
          })
        );
      }
    } catch (err) {
      if (err instanceof ConnectError) {
        console.log('Error:', err.rawMessage);
        dispatch(
          setToastInfoV2({
            label: err.rawMessage,
            variant: 'error',
            open: true,
          })
        );
      } else {
        dispatch(
          setToastInfoV2({
            label: 'Error while generating report',
            variant: 'error',
            open: true,
          })
        );
      }
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------------------------------

  const fetchStudentReport = async (rollNumber: string) => {
    try {
      if (!assessment_id || !rollNumber) {
        return;
      }
      setLoading(true);
      const res =
        await SchoolAssessmentAPIServiceV1ClientWithStatusCodeHandler.fetchStudentOMRKdtAssessmentReport(
          {
            assessmentId: Number(assessment_id),
            rollNumber: rollNumber,
          }
        );
      if (res.data?.gcpReportUrl) {
        setPdfUrl(getMediaBasePath(res.data?.gcpReportUrl));
      } else {
        dispatch(
          setToastInfoV2({
            label: res.message,
            variant: 'success',
            open: true,
          })
        );
      }
    } catch (err) {
      if (err instanceof ConnectError) {
        console.log('Error:', err.rawMessage);
        dispatch(
          setToastInfoV2({
            label: err.rawMessage,
            variant: 'error',
            open: true,
          })
        );
      } else {
        dispatch(
          setToastInfoV2({
            label: 'Error while generating report',
            variant: 'error',
            open: true,
          })
        );
      }
    } finally {
      setLoading(false);
    }
  };
  // -----------------------------------------------------

  const onDownloadClick = (
    reportType: 'teacher' | 'student',
    isBulk: boolean,
    rollNumber: string
  ) => {
    if (reportType == 'student' && isBulk) {
      fetchStudentBulkReports();
    } else if (reportType == 'teacher') {
      fetchTeacherReport();
    } else if (reportType == 'student' && !isBulk && rollNumber) {
      fetchStudentReport(rollNumber);
    }
  };

  // -----------------------------------------------------

  if (loading) {
    return <Loader />;
  }

  return (
    <Box sx={styles.root}>
      {/* ---------- Header Container ---------- */}

      <Box sx={styles.leftContainer}>
        <Box sx={styles.header}>
          <ImageWrapper
            name="chapterImage"
            type="png"
            parentFolder="tempAssets"
            path={getMediaBasePath(
              activeAssessment?.assessment?.assessmentPosterImgUrl,
              'processedMediaBucket'
            )}
            styles={styles.headImage}
          />
          <Box
            sx={{
              width: { xs: '70%', md: pxTovW(390) },
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(14), md: pxTovW(15) },
            }}
          >
            <Box>
              <Typography
                variant="h1"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  wordWrap: 'break-word',
                }}
              >
                {activeAssessment?.assessment?.assessmentTitle}
              </Typography>
              <Typography
                variant={isIpadOnly ? 'h4' : 'button'}
                color="primary"
                fontWeight="regular"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  width: '90%',
                }}
              >
                {activeAssessment?.assessment?.class || ''}
                {activeAssessment?.assessment?.section || ''}{' '}
                {activeAssessment?.assessment?.subject || ''} |{' '}
                {activeAssessment?.assessment?.moduleName || ''}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box>
          <Button
            startIcon={
              <IconWrapper
                name="scan-white"
                type="png"
                parentFolder="icons"
                size="md"
              />
            }
            onClick={() => setOpenOmrUploadPopup(true)}
            sx={{
              backgroundColor: '#0AA34F',
              padding: { xs: pxToRem(10), md: pxTovW(10) },
              '&:hover': {
                backgroundColor: 'success.main',
              },
            }}
          >
            <Typography variant="h4" color="white">
              Scan Student Answer Sheet
            </Typography>
          </Button>
        </Box>

        <Box>
          <ReportButton
            buttonText="Reports"
            buttonList={[
              {
                name: 'Teacher Report',
                onClick: async () => {
                  onDownloadClick('teacher', false, '');
                },
              },
              {
                name: 'Student Report (Bulk)',
                onClick: async () => {
                  onDownloadClick('student', true, '');
                },
              },
            ]}
          />
          {/* <Button
            startIcon={
              <IconWrapper
                name="download"
                type="png"
                parentFolder="icons"
                size="small"
              />
            }
            onClick={reportButtonClick}
            sx={{
              border: '1px solid #0AA34F',
              padding: { xs: pxToRem(10), md: pxTovW(10) },
              '&:hover': {
                borderColor: 'success.main',
              },
            }}
          >
            <Typography variant="h4" color="success.main">
              Report
            </Typography>
          </Button>

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={styles.popoverBox}
          >
            <Box>
              {['Teacher Report', 'Student Report'].map((elem, index) => (
                <Box
                  key={index}
                  sx={styles.popoverItem}
                  onClick={() => {
                    handleClose();
                  }}
                >
                  <Typography variant="h5" fontWeight="medium">
                    {elem}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Popover> */}
        </Box>
      </Box>

      <Box sx={styles.rightContainer}>
        <OmrIconDetails
          totalMarks={activeAssessment?.assessment?.maxMarks || 0}
          difficulty={'Medium'}
          totalQuestions={
            activeAssessment?.assessment?.assessmentContentInfo
              ?.numberOfQuestions || 0
          }
        />

        <Box sx={styles.countFilterSortBox}>
          <Box sx={styles.studentCountBox}>
            <Typography variant="h2">Students</Typography>
            <Box sx={styles.startInfoBox}>
              <ImageWrapper
                name="user"
                type="png"
                parentFolder="icons"
                styles={styles.startInfoIcon}
              />

              <Typography variant={'h3'} fontWeight="regular">
                {omrClassStats?.studentPerformanceInfo.length}/
                {omrClassStats?.studentPerformanceInfo.length}
              </Typography>
            </Box>
          </Box>

          {/* <Box sx={styles.filterSortBox}>
            <FilterSortPopup
              iconName="Filter"
              title="Filter"
              options={['All', 'Approved', 'Rejected']}
              filterFunction={() => {}}
            />
            <FilterSortPopup
              iconName="Sort"
              options={['Name', 'Date']}
              title="Sort By"
              filterFunction={() => {}}
            />
          </Box> */}
        </Box>

        {/* ---------- Student Performance Grid Container ---------- */}
        {!!omrClassStats?.studentPerformanceInfo.length ? (
          <Box sx={styles.studentScoreCardGridBox}>
            {omrClassStats?.studentPerformanceInfo?.map((elem, index) => (
              <Box
                onClick={
                  () => onDownloadClick('student', false, elem.studentId)
                  // cardOnClickHandler && cardOnClickHandler(String(elem.studentId))
                }
                sx={{ cursor: 'pointer' }}
              >
                <StudentScoreCard<StudentOmrPerformanceInfo>
                  studentName={elem.name}
                  maxMarks={activeAssessment?.assessment?.maxMarks || 0}
                  score={Math.round(elem.scorePercent)}
                  marks={elem.responseScore}
                  imageUrl={firstLetterImage(elem.name)}
                  studentPerformanceInfo={elem}
                  linearProgressStyles={{
                    borderRadius: { xs: pxToRem(4), md: pxTovW(10) },
                  }}
                  rootStyles={{
                    // width: { xs: '90vw', md: pxTovW(510), lg: pxTovW(340) },
                    width: { xs: 'inherit', md: pxTovW(450), lg: pxTovW(340) },
                  }}
                  withoutArrow
                />
              </Box>
            ))}
          </Box>
        ) : (
          <NoContentCard
            variant="info"
            icon="cards"
            text="Student Performance Data Not Available"
          />
        )}
      </Box>

      <OmrUploadPopup
        open={openOmrUploadPopup}
        handleClose={() => setOpenOmrUploadPopup(false)}
        handleDropFunction={handleDropFunction}
        handleChangeFunction={handleChangeFunction}
        handleDeleteFunction={handleDeleteFunction}
        userUploads={file ?? []}
        isUploading={loading}
      />

      {pdfUrl && (
        <DocumentViewer
          downloadUrl={pdfUrl}
          previewUrl={pdfUrl}
          gcpUrl={pdfUrl}
          type={FileEnum.FILE_TYPE_PDF}
          fileName={
            activeAssessment?.assessment?.subject ||
            activeAssessment?.assessment?.class ||
            activeAssessment?.assessment?.section
              ? `${activeAssessment?.assessment?.subject || ''}_${
                  activeAssessment?.assessment?.class || ''
                }_${
                  activeAssessment?.assessment?.section || ''
                }_Geneo_Assessment_Report.pdf`
              : `Geneo_Assessment_Report.pdf`
          }
          open={!!pdfUrl}
          closeFile={() => {
            setPdfUrl(undefined);
          }}
        />
      )}
    </Box>
  );
};
